/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleType } from './VehicleType';
import {
	VehicleTypeFromJSON,
	VehicleTypeFromJSONTyped,
	VehicleTypeToJSON,
	VehicleTypeToJSONTyped,
} from './VehicleType';

/**
 *
 * @export
 * @interface VehicleDto
 */
export interface VehicleDto {
	/**
	 *
	 * @type {string}
	 * @memberof VehicleDto
	 */
	platNumber?: string | null;
	/**
	 *
	 * @type {number}
	 * @memberof VehicleDto
	 */
	userProvidedMileage?: number | null;
	/**
	 *
	 * @type {VehicleType}
	 * @memberof VehicleDto
	 */
	vehicleTypeId?: VehicleType;
}

/**
 * Check if a given object implements the VehicleDto interface.
 */
export function instanceOfVehicleDto(value: object): value is VehicleDto {
	return true;
}

export function VehicleDtoFromJSON(json: any): VehicleDto {
	return VehicleDtoFromJSONTyped(json, false);
}

export function VehicleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleDto {
	if (json == null) {
		return json;
	}
	return {
		platNumber: json['platNumber'] == null ? undefined : json['platNumber'],
		userProvidedMileage:
			json['userProvidedMileage'] == null ? undefined : json['userProvidedMileage'],
		vehicleTypeId:
			json['vehicleTypeId'] == null ? undefined : VehicleTypeFromJSON(json['vehicleTypeId']),
	};
}

export function VehicleDtoToJSON(json: any): VehicleDto {
	return VehicleDtoToJSONTyped(json, false);
}

export function VehicleDtoToJSONTyped(
	value?: VehicleDto | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		platNumber: value['platNumber'],
		userProvidedMileage: value['userProvidedMileage'],
		vehicleTypeId: VehicleTypeToJSON(value['vehicleTypeId']),
	};
}
